<!-- 销售结算记账数据操作 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <purchaseGoodsTemplate @selectDataAction="selectDataAction" ref="purchaseGoodsTemplate"></purchaseGoodsTemplate>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form class="baseForm" id="mainInfo" label-width="150px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row v-if="dataActionBox.actionType != 2">
                                 <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                               :key="formOneKey" :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                    <!-- 验收单号 -->
                                    <el-input v-if="formOneValue.entityField == 'dsapmId'" @focus="openExtract(formOneValue.extractId, 0, 'dsapmId')" v-model="sendDataInfo.dsapmId" :maxlength="$store.state.inputLength">
                                       <!-- <el-button click="openExtract(formOneValue.extractId, 0, 'dsapmId')" slot="append" icon="el-icon-search"></el-button> -->
                                    </el-input>
                                    <!-- 申请日期 -->
                                    <df-date v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false" :isdisabled="formOneValue.isChange == 0" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                    <!-- 供应商 -->
                                    <el-input :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'smId'" v-model="sendDataInfo.smName" :maxlength="$store.state.inputLength"></el-input>

                                    <!-- 单位业务员 -->
                                    <el-input :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'salesId'" v-model="sendDataInfo.salesName" :maxlength="$store.state.inputLength"></el-input>
                                    <!-- 货主 -->
                                    <el-input :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'coId'" v-model="sendDataInfo.coName" :maxlength="$store.state.inputLength"></el-input>
                                    <!-- 采购员	 -->
                                    <el-input :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'opmId'" v-model="sendDataInfo.opmName" :maxlength="$store.state.inputLength"></el-input>
                                    <!-- 业务部门 -->
                                    <el-input :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'depId'" v-model="sendDataInfo.depName" :maxlength="$store.state.inputLength"
                                              :readonly="formOneValue.isChange == 0"></el-input>
                                    <!-- 账簿 -->
                                    <el-input v-else-if="formOneValue.entityField == 'abookCode'" @focus="openSearch(formOneValue.searchId, formOneValue.setField, formOneValue.entityField)"
                                              v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" :readonly="formOneValue.isChange == 0">
                                       <!-- <el-button click="openSearch(formOneValue.searchId, formOneValue.setField, formOneValue.entityField)" slot="append" icon="el-icon-search" :readonly="formOneValue.isChange == 0"></el-button> -->
                                    </el-input>
                                    <!-- 备注 -->
                                    <el-input :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'remark'" type="textarea" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                              :maxlength="$store.state.inputLength">
                                    </el-input>
                                    <el-input :disabled="formOneValue.isChange == 0" v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength">
                                    </el-input>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                               :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.entityField == 'opmId'">{{ sendDataInfo.opmName }}</span>
                                    <span v-else-if="formOneValue.entityField == 'smId'">{{ sendDataInfo.smName}}</span>
                                    <span v-else-if="formOneValue.entityField == 'coId'">{{ sendDataInfo.coName}}</span>
                                    <span v-else-if="formOneValue.entityField == 'depId'">{{sendDataInfo.depName }}</span>
                                    <span v-else-if="formOneValue.entityField == 'salesId'">{{sendDataInfo.salesName }}</span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                                       </span>
                                    </span>
                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <!-- 明细信息 -->
                           <div>
                              <div class="flex" style="margin-bottom: 10px;" id="operateBtn">
                                 <el-radio-group v-model="tableType" disabled>
                                    <el-radio-button :label="0">按单据结算</el-radio-button>
                                    <el-radio-button :label="1">按明细结算</el-radio-button>
                                 </el-radio-group>
                              </div>
                              <el-table size="mini" v-show="tableType == 0" :data="sendDataInfo.suSettleInvoiceVos" :row-class-name="tableRowClassName" border style="width: 100%" :height="mxHeight">
                                 <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" v-for="(formOneValue, formOneKey) in mxForm1"
                                                  :key="formOneKey" v-if="formOneValue.isShow == 1">
                                    <template slot-scope="scope">
                                       <span v-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(scope.row[formOneValue.riftField])">{{scope.row[formOneValue.entityField] }}</a>
                                       </span>
                                       <span v-else-if="formOneValue.fieldType == 'date' && scope.row[formOneValue.entityField]">
                                          {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                       </span>
                                       <span v-else-if="formOneValue.fieldType == 'formatter'">{{getValue(scope.row[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)}}</span>
                                       <span v-else>{{sendDataInfo.suSettleInvoiceVos[scope.$index][formOneValue.entityField]}}</span>
                                    </template>
                                 </el-table-column>
                              </el-table>
                              <el-table size="mini" v-show="tableType == 1" :data="sendDataInfo.suSettleInvoiceDetailVos" :row-class-name="tableRowClassName" border style="width: 100%" :height="mxHeight">
                                 <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" v-for="(formOneValue, formOneKey) in mxForm2"
                                                  :key="formOneKey" v-if="formOneValue.isShow == 1">
                                    <template slot-scope="scope">
                                       <span v-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(scope.row[formOneValue.riftField])">{{scope.row[formOneValue.entityField] }}</a>
                                       </span>
                                       <span
                                             v-else-if="formOneValue.fieldType == 'formatter'">{{getValue(scope.row[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)}}</span>
                                       <span v-else-if="formOneValue.fieldType == 'date' && scope.row[formOneValue.entityField]">
                                          {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                       </span>
                                       <span v-else>{{sendDataInfo.suSettleInvoiceDetailVos[scope.$index][formOneValue.entityField]}}</span>
                                    </template>
                                 </el-table-column>
                              </el-table>
                           </div>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <div class="foot">
               <div>
                  <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
                  </el-button>
                  <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType != 2">取消</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
               </div>
               <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
                  <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                     <el-button type="success">{{ itemV.entityField == 'totalMoney' ?
                                $common.getDecimalInfo(3, sendDataInfo[itemV.entityField]) :
                                sendDataInfo[itemV.entityField] }}</el-button>
                     <!-- <el-button type="success">{{itemV.entityField == 'totalMoney' ? sendDataInfo[itemV.entityField].toFixed(2) : sendDataInfo[itemV.entityField]}}</el-button> -->
                  </el-form-item>
               </el-form>
            </div>
         </div>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
         <ExtractionSchemeSalesSettle ref="ExtractionSchemeSalesSettle" :exType="exType" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionSchemeSalesSettle from "../byComponents/ExtractionSchemeSalesSettle.vue";
  import purchaseGoodsTemplate from "@/components/purchaseGoodsTemplate.vue";
export default {
   name: 'salesSettleKeepAction',
   props: ['actionData'],
   //import引入的组件需要注入到对象中才能使用
   components: {
      ExtractionSchemeSalesSettle,
      SearchScheme,
      purchaseGoodsTemplate
   },
   data() {
      //这里存放数据
      return {
         selectDataTable: false,
         dataActionBox: {
            showStatus: false,
            openMode: 'ltr' || 'rtl',
            boxTitle: '新增' || '编辑',
            actionType: 0, // 0新增，1修改
         },
         detaislDataInfo: {},
         selectedDataIndex: 0,
         selectedDataIndex1: 0,
         exType: 'xs',
         tableType: 0,
         sendDataInfo: {
            dsapmId: '',
            psacmDate: '',
            "suSettleInvoiceVos": [], //按单据
            "suSettleInvoiceDetailVos": [], //按明细
            "psomBusdept": 0,
            "smId": '',
            "smName": '',
            "dpsmDate": 0,
            "isWms": 0,
            "opmId": 0,
            "opmName": '',
            "pacmRemark": "",
            "desmReserves1": "",
            "desmReserves2": "",
            "desmReserves3": "",
            "desmReserves4": "",
            "desmReserves5": "",
            "desmReserves6": "",
            "salesId": "",
            "salesName": "",
            "totalCount": 0,
            "totalMoney": 0,
            "totalNumber": 0,
            "psaiId": '',
            'psomId': '',
            "depId": "",
            "depName": "",
            "coId": '',
            "coName": '',
            sbiAddress: '',
            sbiNumber: '',
            sbiName: '',
            settleMode: '',
            payMethod: '',
            abookCode: "", //账簿编号
            abookId: 0, //账簿id
            abookName: "", //账簿名称
            checkNo: "", //支票号
            remark: "" //备注
         },
         showTabs: '',
         formDataList: [],
         dictionariesData: {},
         userOneList: [],
         goodsList: [],
         storageRoomList: [],
         salesmanList: [],
         detailsBox: {
            status: false,
            type: 0,
            title: "新增" || "修改",
         },
         editDateilsIndex: "",
         exId: "",
         seId: "",
         ceshi: "",
         dialogTitle: "",
         seWidth: "",
         height: "",
         exTitle: "",
         seTitle: "",
         seWidth: "",
         exWidth: "",
         DialogVisible: false,
         DialogVisible1: false,
         DialogExtract: false,
         newFormDataList: [],
         seType: '',
         sField: "",
         smId: '',
         parentSearchData: {
            smId: ''
         },
         parentSearchData1: {
            smId: '',
            coId: '',
            opmId: '',
            salesId: '',
            depId: ''
         },
         searchId: '',
         mxHeight: 0,
         tabForm: [], // tab循环的主表单
         mxForm1: [],
         mxForm2: [],
         footForm: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {},
   //方法集合
   methods: {
      getValue(val, type, fieldType, arr) {
         var str = ""
         if (fieldType == 'formatter') {
            if (arr) {
               JSON.parse(arr).forEach(item => {
                  if (String(Number(item.value)) != NaN && item.value == val) {
                     str = item.key
                  } else if (String(Number(item.key)) != NaN && item.key == val) {
                     str = item.value
                  }
               })
            }
         } else {
            str = val || ""
         }
         return String(str)
      },
      tabHeight(val) {
         this.mxHeight = val
      },
      showPrintPlan() { // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据 
            this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData
               .printJurId)
         } else {
            return
         }
      },
      // 子组件穿透方法
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
         else this.$parent.$parent.$parent.toDetail(orderId)
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.paramValue(val)
         }
         this.DialogVisible = false
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = val[item]
            console.log(this.sendDataInfo[item])
         })
      },
      async getDataByChen(val) {
         if (val != "" || val != undefined) {
            this.tableType = val.settleMode
            for (let key in val) {
               this.sendDataInfo[key] = val[key]
            }
            this.DialogExtract = false;
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      // 提取方案Id, 索引(表格中), 标识
      openExtract(eId, index, type) {
         this.DialogExtract = true
         this.exId = eId
         this.seType = type
         this.ppId = 'pscamId'
      },

      getSelect() {
         var mx = this.$refs.searchSchemeMultiple.multipleSelection
         if (this.tableType == 0) {
            this.sendDataInfo.suSettleInvoiceVos = mx
            this.sendDataInfo.suSettleInvoiceVos.forEach(item => {
               this.$set(item, 'settleMoney', 0)
            })
            this.sendDataInfo.totalCount = this.sendDataInfo.suSettleInvoiceVos.length
         } else if (this.tableType == 1) {
            this.sendDataInfo.suSettleInvoiceDetailVos = mx
            this.sendDataInfo.suSettleInvoiceDetailVos.forEach(item => {
               this.$set(item, 'settleMoney', 0)
            })
            this.sendDataInfo.totalCount = this.sendDataInfo.suSettleInvoiceDetailVos.length
         }
         this.DialogVisible1 = false
         this.sendDataInfo.totalMoney = 0
      },
      extract(sendDataInfo) {
         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               if (this.tableType == 0) this.searchId = '610674495066112'
               else if (this.tableType == 1) this.searchId = '614769050128384'
               this.DialogVisible1 = true
            }
         })
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getExtractName(e) {
         console.log(e);
         this.exTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, sField, type) {
         if (type == 'salesId' || type == 'sbiAddress') {
            if (this.parentSearchData.smId == '') {
               return this.$message({
                  message: '请先选择供应商',
                  type: 'warning'
               });
            }
         }
         this.DialogVisible = true
         this.seId = sId
         this.sField = sField;
         this.seType = type

      },
      tableRowClassName({
         row,
         rowIndex
      }) {
         row.index = rowIndex;
      },
      detailsAction(cate = 0) {
         if (cate == 0) {
            this.editDateilsIndex = ""
            return false
         }

         var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo))
         if (dataInfo.psodPacknum <= 0) {
            this.$message({
               message: '请填写采购数量',
               type: 'error'
            });
            return false
         }
         if (this.editDateilsIndex !== "") {
            this.sendDataInfo.pisOrderDetail.splice(this.editDateilsIndex, 1)
         }
         this.sendDataInfo.pisOrderDetail.push(dataInfo)
         // console.log('this.sendDataInfo.pisOrderDetail',this.sendDataInfo.pisOrderDetail)
         this.editDateilsIndex = ""
         this.detailsBox.status = false
      },
      initActionBox(sendDataInfo) {
         this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.$common.delOrderInfo(this.sendDataInfo.dsapmId)
            this.$emit('drawerCancel')
            this.init()
            this.$refs.sendDataInfo.resetFields();
         }).catch(() => { });

      },
      init() {
         for (let key in this.sendDataInfo) {
            if (key == 'pisOrderAuxinf') {
               for (let sonOne in this.sendDataInfo[key]) {
                  this.sendDataInfo[key][sonOne] = ''
               }
            } else {
               this.sendDataInfo[key] = ''
            }
         }
         this.sendDataInfo.dpsmDate = this.$moment().valueOf();

         this.sendDataInfo.suSettleInvoiceDetailVos = []
         this.sendDataInfo.suSettleInvoiceVos = []
         this.sendDataInfo.isWms = 0
         this.sendDataInfo.totalMoney = 0
         this.sendDataInfo.totalNumber = 0
         this.sendDataInfo.totalCount = 0
      },

      // 选择采购员
      selectUserOne(data) {
         data.forEach(item => {
            if (item.opmId == this.sendDataInfo.opmId) {
               this.sendDataInfo.psomBusdept = item.depId
            }
         })
      },
      async isShowData(name, value) {
         switch (name) {
            case 'supplier':
               var dataInfo = sessionStorage.getItem('selectSupplierData')
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo)
                  this.sendDataInfo.smId = dataInfo.smId
                  this.sendDataInfo.smName = dataInfo.smName

               }
               this.sendDataInfo.salesId = ''
               this.getUnitSalesmanList()
               break;
            case 'cargoOwner':
               var dataInfo = sessionStorage.getItem('selectCargoOwnerData')
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo)
                  this.sendDataInfo.pisOrderAuxinf.coId = dataInfo.coId
                  this.sendDataInfo.pisOrderAuxinf.coName = dataInfo.coName
               }
               break;


         }


      },
      selectDataAction(data) {
         this.detaislDataInfo = {
            // "bgmId":data.bgmId,
            "bgmId": data.bgmId,
            "bgmName": data.bgmName,
            "inRate": data.bgfIntaxrate,
            bgmManufacturer: data.bgmManufacturer,
            bgmSpecifications: data.bgmSpecifications,
            bgmPlaceorigin: data.bgmPlaceorigin,
            "money": 0,
            "psodPacknum": 0,
            "price": 0,
            "psodPsdvolume": 0,
            "psodPslowerlimit": 0,
            "psmoney": 0,
            "psodPsnvolume": 0,
            "psprice": 0,
            "psodPsupperlimit": 0,
            "pspmId": '',
            "stId": data.stId,
            "pspdId": '',
            bgpUnitmeasurement: "", // 包装单位
            packingSpec: "", // 装箱规格
            "psodReserves1": "",
            "psodReserves2": "",
            "psodReserves3": "",
            "psodReserves4": "",
            "psodReserves5": "",
            "psodReserves6": "",
         }
         this.selectDataTable = false
      },

      openBox() {
         this.dataActionBox.actionType = this.actionData.cate
         this.formDataList = this.actionData.formData
         var oldData = this.actionData.oldData
         this.showTabs = this.actionData.formData[0].jciName
         this.filterMainField()
         this.init()
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = '新增信息'
            this.dataActionBox.openMode = 'ltr'
            for (let key in this.parentSearchData) {
               this.parentSearchData[key] = ''
            }
            this.sendDataInfo.psacmDate = this.$moment().valueOf();
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = '编辑信息'
            this.dataActionBox.openMode = 'rtl'
            var dataInfo = JSON.parse(JSON.stringify(oldData))
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key]
            }
            this.smId = dataInfo.smId
            this.getUnitSalesmanList()
         } else {
            this.dataActionBox.boxTitle = '查看信息'
            var dataInfo = JSON.parse(JSON.stringify(oldData))
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key]
            }
            this.tableType = this.sendDataInfo.settleMode
            if (this.tableType == 0) {
               this.sendDataInfo.suSettleInvoiceVos = this.sendDataInfo.suSettleAccountInvoiceVos
            } else {
               this.sendDataInfo.suSettleInvoiceDetailVos = this.sendDataInfo.suSettleAccountInvoiceDetailVos
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getHeight()
               }
            }, 100)
         })
      },
      sendDataAction(sendDataInfo) {
         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               this.sub(sendDataInfo)
            } else {
               console.log('error submit!!');
               return false;
            }
         })
      },
      async sub(sendDataInfo) {
         if (this.tableType == 0) {
            this.sendDataInfo.settleMode = 0
            var data1 = []
            this.sendDataInfo.suSettleInvoiceVos.forEach(item => {
               data1.push({
                  dasmId: item.dasmId,
                  dsapdId: item.dsapdId,
                  oldBalance: item.oldBalance,
                  settleMoney: item.settleMoney
               })
            })
            this.sendDataInfo.suSettleAccountDetailAdds = data1
         } else {
            this.sendDataInfo.settleMode = 1
            var data2 = []
            this.sendDataInfo.suSettleInvoiceDetailVos.forEach(item => {
               data2.push({
                  dasdId: item.dasdId,
                  dsapdId: item.dsapdId,
                  oldBalance: item.oldBalance,
                  settleMoney: item.settleMoney
               })
            })
            this.sendDataInfo.suSettleAccountDetailAdds = data2
         }
         console.log(this.sendDataInfo.abookName, this.sendDataInfo.abookCode)
         if (!this.sendDataInfo.abookName || !this.sendDataInfo.abookCode) {
            return this.$message({
               message: '请完善账簿信息',
               type: 'error'
            });
         }
         var responseData = await this.$http.addSalesSettlementKeep(this.sendDataInfo)
         if (responseData.status == 200) {
            this.init()
            this.$message({
               message: '操作成功',
               type: 'success'
            });
            this.$refs.sendDataInfo.resetFields();
            this.$emit('drawerCancel')

         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      deleteDetails() {
         if (this.tableType == 0) {
            if (this.sendDataInfo.suSettleInvoiceVos.length > 0) {
               this.sendDataInfo.suSettleInvoiceVos.splice(this.selectedDataIndex, 1)
               this.selectedDataIndex = 0
               this.sendDataInfo.totalCount = this.sendDataInfo.suSettleInvoiceVos.length
            } else {
               return this.$message({
                  message: '暂无可删除明细',
                  type: 'warning'
               })
            }
         } else if (this.tableType == 1) {
            if (this.sendDataInfo.suSettleInvoiceDetailVos.length > 0) {
               this.sendDataInfo.suSettleInvoiceDetailVos.splice(this.selectedDataIndex1, 1)
               this.selectedDataIndex1 = 0
               this.sendDataInfo.totalCount = this.sendDataInfo.suSettleInvoiceDetailVos.length
            } else {
               return this.$message({
                  message: '暂无可删除明细',
                  type: 'warning'
               })
            }
         }
      },
      // 获取业务员
      async getUnitSalesmanList() {

         this.salesmanList = []
         let responseData = await this.$http.getUnitSalesmanList({
            ids: [this.sendDataInfo.smId]
         })
         if (responseData.status == 200) {
            this.salesmanList = responseData.result
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },

      // 获取供货员
      async getSpecialUser() {

         let responseData = await this.$http.getSpecialUser({
            opmBuyer: 1
         })
         if (responseData.status == 200) {
            this.userOneList = responseData.result
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },

      // 获取字典数据
      async getPartDictionariesData() {
         let responseData = await this.$http.getPartDictionariesData({
            ids: [20, 21]
         })
         if (responseData.status == 200) {
            this.dictionariesData = responseData.result
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },

      // 获取所有可用库房列表
      async getAllStorageRoom() {
         let responseData = await this.$http.getAllStorageRoom()
         if (responseData.status == 200) {
            this.storageRoomList = responseData.result
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         let formArr = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               formArr.push(JSON.parse(JSON.stringify(item.jurconfigform)))
               // this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         this.mxForm1 = formArr[0]
         this.mxForm2 = formArr[1]
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key))
            this.tabForm[i].jurconfigform = []
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
                  .jurconfigform[index])
            }
         })
      }



   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox()
      })
      this.getSpecialUser()
      this.getUnitSalesmanList()
      this.getPartDictionariesData()
      this.getAllStorageRoom()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-drawer {
   outline: none;
}

.flex {
   display: flex;
   align-items: center;
}
</style>